import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { House, Car, Tag, ChartLineUp, UserCircle } from "@phosphor-icons/react";

const items = [
  { to: "/", icon: House, label: "Home", tid: "nav-home" },
  { to: "/buy", icon: Car, label: "Buy", tid: "nav-buy" },
  { to: "/sell", icon: Tag, label: "Sell", tid: "nav-sell" },
  { to: "/activity", icon: ChartLineUp, label: "Activity", tid: "nav-activity" },
  { to: "/account", icon: UserCircle, label: "Account", tid: "nav-account" },
];

export default function FloatingBottomNav() {
  const loc = useLocation();
  // Hide nav on /login, /admin, and public legal pages
  if (
    loc.pathname.startsWith("/login") ||
    loc.pathname.startsWith("/admin") ||
    loc.pathname.startsWith("/privacy-policy") ||
    loc.pathname.startsWith("/terms")
  ) return null;

  return (
    <nav
      data-testid="floating-bottom-nav"
      className="fixed bottom-4 qd-pb-safe-fab left-1/2 -translate-x-1/2 z-50 qd-glass rounded-full px-1.5 py-1.5 flex items-center gap-0.5"
      style={{ boxShadow: "0 12px 30px -8px rgba(0,0,0,0.7)" }}
    >
      {items.map(({ to, icon: Icon, label, tid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          data-testid={tid}
          className={({ isActive }) =>
            `relative flex flex-col items-center justify-center px-3.5 py-2 rounded-full min-w-[56px] transition-colors duration-200 ${
              isActive
                ? "text-[#E55A5A] bg-white/[0.03]"
                : "text-white/45 hover:text-white/80"
            }`
          }
          style={({ isActive }) =>
            isActive ? { boxShadow: "inset 0 0 0 1px rgba(225,29,29,0.35)" } : {}
          }
        >
          {({ isActive }) => (
            <>
              <Icon size={isActive ? 19 : 18} weight={isActive ? "fill" : "regular"} />
              <span className="text-[9px] font-medium tracking-[0.12em] mt-1 uppercase">{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
